// Wasapi fork: the product ships in Portuguese (Brazil), Spanish and English only, so the other
// locale bundles are not imported (they add ~30MB of JSON to the dashboard build). Keep this list
// in sync with WASAPI_ENABLED_LOCALES in config/initializers/wasapi_languages.rb.
import en from './locale/en';
import es from './locale/es';
import pt_BR from './locale/pt_BR';

export default {
  en,
  es,
  pt_BR,
};
